import { useState, useEffect } from "react";
import {
    getSchoolRubricScoreService,
} from "../../../../services/school.service";
import {
    getNationalGlobalRubricScoreService,
} from "../../../../services/individual.service";
import {getRubricNames} from "../../../../utils/utils";

function processAllRubricData({ rubric_school, rubric_national_global, assess_indicators }) {
    const overall = assess_indicators.map((indicator, i) => {
        const school = rubric_school.find(r => r.assess_code === indicator.indicator_code);
        const national = rubric_national_global.find(r => r.assess_code === indicator.indicator_code && r.country !== "Global");
        const global = rubric_national_global.find(r => r.assess_code === indicator.indicator_code && r.country === "Global");
        const rubricNames = getRubricNames(indicator);

        return {
            category: indicator.name,
            code: indicator.indicator_code,
            greyed: i % 2 === 0,
            rubricNames,
            description: indicator.description,
            rows: [
                {
                    label: "Your School",
                    highlightCol: school?.rubricLevelAVG ? 4 - school.rubricLevelAVG : null, // 0=veryActive, 1=active,...
                },
                {
                    label: "National Average",
                    highlightCol: national?.rubricLevel ? 4 - national.rubricLevel : null,
                },
                {
                    label: "Global Average",
                    highlightCol: global?.rubricLevel ? 4 - global.rubricLevel : null,
                },
            ],
        };
    });

    const groupKeys = {
        byAge: "distribution_age",
        byLevel: "distribution_section_level",
        byClass: "distribution_section_code"
    };

    // Build breakdowns for each group and source (school/national/global)
    function buildGroupData(key, distKey) {
        const breakdown = {};

        function addDistToBreakdown(items, source) {
            items.forEach(item => {
                const groupDist = item[distKey];
                if (!groupDist) return;
                Object.entries(groupDist).forEach(([groupValue, dist]) => {
                    if (!breakdown[groupValue]) breakdown[groupValue] = {};
                    if (!breakdown[groupValue][item.assess_code]) breakdown[groupValue][item.assess_code] = {};
                    breakdown[groupValue][item.assess_code][source] = dist;
                });
            });
        }

        addDistToBreakdown(rubric_school, "school");
        rubric_national_global.filter(r => r.country !== "Global").forEach(item => {
            if (!breakdown["National"]) breakdown["National"] = {};
            if (!breakdown["National"][item.assess_code]) breakdown["National"][item.assess_code] = {};
            breakdown["National"][item.assess_code]["national"] = item.distribution;
        });
        rubric_national_global.filter(r => r.country === "Global").forEach(item => {
            if (!breakdown["Global"]) breakdown["Global"] = {};
            if (!breakdown["Global"][item.assess_code]) breakdown["Global"][item.assess_code] = {};
            breakdown["Global"][item.assess_code]["global"] = item.distribution;
        });

        return breakdown;
    }

    const groupData = {};
    Object.entries(groupKeys).forEach(([key, distKey]) => {
        groupData[key] = buildGroupData(key, distKey);
    });

    return {
        overall,
        byAge: groupData.byAge,
        byLevel: groupData.byLevel,
        byClass: groupData.byClass
    };
}

export function useSchoolRubricData(org_code, module_code, institute_code, org_country) {
    const [loading, setLoading] = useState(false);
    const [processedRubricSchool, setProcessedRubricSchool] = useState({
        overall: [],
        byAge: {},
        byLevel: {},
        byClass: {},
    });
    const [assessIndicators, setAssessIndicators] = useState([]);

    useEffect(() => {
        async function loadPageData() {
            if (!org_code || !module_code || !institute_code) {
                setLoading(false);
                return;
            }
            setLoading(true);
            try {
                const result_school = await getSchoolRubricScoreService(
                    org_code,
                    module_code,
                    institute_code,
                );
                console.log('result_school', result_school);
                const { rubric_school, assess_indicators } = result_school.data;
                let rubric_national_global = [];
                if (rubric_school && rubric_school.length > 0) {
                    const assess_code_list = rubric_school.map(item => item.assess_code);
                    console.log('assess_code_list', assess_code_list);
                    const result_national_global = await getNationalGlobalRubricScoreService(
                        org_country,
                        assess_code_list
                    );
                    rubric_national_global = result_national_global.data.rubric_national_global || [];
                }
                console.log('national_global', rubric_national_global);

                setAssessIndicators(assess_indicators);
                setProcessedRubricSchool(processAllRubricData({
                    rubric_school,
                    rubric_national_global,
                    assess_indicators
                }));
            } catch (e) {
                console.log("Some error occurred while fetching Rubric Score", e);
            } finally {
                setLoading(false);
            }
        }

        loadPageData();
    }, [org_code, module_code, institute_code, org_country]);

    return {
        loading,
        processedRubricSchool,
        assessIndicators
    };
}
